<template>
  <b-container fluid>
    <b-row>
      <b-col :lg="cols">
        <card>
          <TableActionHeader
            v-on:filterChange="onFilterChange"
            v-on:newItem="onNewItem"
            :newButton="
              $UIPrivilegeCreate('realtime', 'vehiclegroups') &&
              !showVehicleTable
            "
          >
          </TableActionHeader>
          <VehicleGroupTable
            v-if="!showVehicleTable"
            :filter="filter"
            v-on:selectItem="onSelectItem"
          ></VehicleGroupTable>
          <VehicleTable
            v-if="showVehicleTable"
            :filter="filter"
            v-on:actionAdd="onAddVehicle"
            :exclusions="selectedVehicles"
            :showAddButton="true"
            :selectable="false"
          ></VehicleTable>
        </card>
      </b-col>
      <b-col>
        <InfoCard v-if="formType == ''"></InfoCard>
        <card v-if="formType == 'new'">
          <CardHeader :title="$t('item.new')" />
          <VehicleGroupForm :item="item" :action="formType"></VehicleGroupForm>
        </card>
        <card>
          <tabs v-if="formType == 'edit'" @activate-tab="onTabChange">
            <tab-pane title="vehicle-group-form" key="vehicle-group-form">
              <b-icon slot="title" icon="gear" scale="1.1"></b-icon>
              <CardHeader :title="item ? item.name : ''" type="item" />
              <VehicleGroupForm
                :item="item"
                :action="formType"
              ></VehicleGroupForm>
            </tab-pane>
            <tab-pane title="member-vehicles" key="member-vehicles">
              <b-icon slot="title" icon="card-list" scale="1.1"></b-icon>
              <!-- CardHeader :title="$t('vehicle_groups.vehicles')" / -->
              <CardHeader
                :title="item ? item.name : $t('vehicle_groups.members')"
                type="item"
              />
              <b-table
                small
                striped
                :fields="vehicleListFields"
                :items="item.vehicles"
                thead-tr-class="vehiclegroup-list-headtr"
                tbody-tr-class="vehiclegroup-list-bodytr"
              >
                <template v-slot:cell(actions)="data">
                  <b-icon
                    v-if="$UIPrivilegeUpdate('realtime', 'vehiclegroups')"
                    :title="$t('vehicle_groups.remove')"
                    icon="x-circle"
                    variant="danger"
                    style="cursor: pointer; margin-right: 20px"
                    @click="removeVehicle(data.item.vehicleId)"
                  />
                </template>
              </b-table>
              <!-- div v-for="vehicle in item.vehicles" :key="vehicle.vehicleId" style="margin-bottom: 5px;">
                                <b-icon v-if="$UIPrivilegeUpdate('realtime', 'vehiclegroups')" :title="$t('vehicle_groups.remove')"
                                    icon="x-circle" variant="danger" style="cursor: pointer; margin-right: 20px;" @click="removeVehicle(vehicle.vehicleId)" />
                                <span style="margin-right: 20px;">{{ vehicle.vehicleLabel }}</span>
                                <span style="margin-right: 20px;">{{ vehicle.features.VEHICLE_TYPE }}</span>
                                {{ vehicle.features.VEHICLE_COMPUTER_TYPE }}
                            </div -->
              <FormButtons
                @submit="submit"
                :submit="$UIPrivilegeUpdate('realtime', 'vehiclegroups')"
                :reset="false"
                :remove="false"
                :itemid="String(item.id)"
                :modalid="'vehicleGroupEditModal'"
                :disableSubmit="loading"
                :disableRemove="loading"
              />
              <RequestInfo
                type="save"
                :ok="ok"
                :error="error"
                :loader="loading"
              />
            </tab-pane>
          </tabs>
        </card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import TableActionHeader from '@/components/Misc/TableActionHeader'
import CardHeader from '@/components/Misc/CardHeader'
import VehicleGroupTable from '@/components/Realtime/VehicleGroupTable.vue'
import VehicleGroupForm from '@/components/Realtime/VehicleGroupForm.vue'
import VehicleTable from '@/components/Realtime/VehicleTable.vue'
import realtime from '@/store/realtime/realtime'

export default {
  name: 'VehicleGroups',
  components: {
    TableActionHeader,
    CardHeader,
    VehicleGroupTable,
    VehicleGroupForm,
    VehicleTable,
  },
  data: function () {
    return {
      showVehicleTable: false,
      showForm: true,
      cols: 8,
      filter: null,
      item: {
        id: null,
        name: null,
        organization: null,
        vehicles: [],
      },
      defaultFormData: {
        id: null,
        name: null,
        organization: null,
        vehicles: [],
      },
      formType: '',
      selectedVehicles: [],
      ok: false,
      error: false,
      loading: false,
    }
  },
  computed: {
    vehicleListFields() {
      let fields = [
        {
          key: 'vehicleLabel',
          label: this.$t('vehicle.label'),
          sortable: false,
        },
      ]
      for (let ovf of this.$store.state.realtime.organizationVehicleFeatures) {
        if (ovf.name == 'VEHICLE_TYPE' || ovf.name == 'VEHICLE_COMPUTER_TYPE') {
          fields.push({
            key: 'features.' + ovf.name,
            label: this.$t(ovf.descriptionId),
            sortable: false,
          })
        }
      }
      //fields.push({ key: 'actions', label: this.$t('vehicle.actions'), sortable: false });
      fields.push({ key: 'actions', label: '', sortable: false })
      return fields
    },
  },
  beforeCreate() {
    if (!this.$store.state.realtime) {
      this.$store.registerModule('realtime', realtime)
    }
    this.$store.dispatch('realtime/getOrganizationVehicleFeatures', null)
  },
  methods: {
    onTabChange(tab) {
      if (
        tab.$vnode.data.key == 'member-vehicles' &&
        this.$UIPrivilegeUpdate('realtime', 'vehiclegroups')
      ) {
        this.showVehicleTable = true
      } else {
        this.showVehicleTable = false
      }
    },
    showEditor(show, type) {
      this.showForm = show
      this.formType = type
      this.cols = this.showForm ? 8 : 12
    },
    onFilterChange(filter) {
      this.filter = filter
    },
    onNewItem() {
      this.item = { ...this.defaultFormData }
      this.showEditor(true, 'new')
    },
    onSelectItem(item) {
      if (item) {
        this.item = JSON.parse(JSON.stringify(item))
        this.showEditor(true, 'edit')

        let sv = []
        for (const v of item.vehicles) {
          sv.push(v.vehicleId)
        }
        this.selectedVehicles = sv
      }
    },
    onAddVehicle(vehicle) {
      let contains = false
      for (const mv of this.item.vehicles) {
        if (!vehicle || vehicle.vehicleId == mv.vehicleId) {
          contains = true
        }
      }
      if (!contains) {
        this.item.vehicles.push(vehicle)
        this.selectedVehicles.push(vehicle.vehicleId)
      }
    },
    removeVehicle(vehicleId) {
      let vehicles = []
      for (const v of this.item.vehicles) {
        if (v.vehicleId != vehicleId) {
          vehicles.push(v)
        }
      }
      this.item.vehicles = vehicles
      let i = this.selectedVehicles.indexOf(vehicleId)
      if (i > -1) {
        this.selectedVehicles.splice(i, 1)
      }
    },
    submit(event) {
      if (event) event.preventDefault()

      this.ok = this.error = false
      this.loading = true

      setTimeout(() => {
        this.$store
          .dispatch('vehicleGroup/saveVehicleGroup', this.item)
          .then((response) => {
            this.ok = response.data.errorCode == 0
            this.error = !this.ok
          })
          .catch(() => {
            this.error = true
          })
          .finally(() => {
            this.loading = false
          })
      }, 1000)
    },
  },
}
</script>

<style lang="scss">
.vehiclegroup-list-headtr th {
  font-size: 11px !important;
  padding: 5px !important;
}

.vehiclegroup-list-bodytr td {
  font-family: Verdana, Arial, Helvetica, sans-serif;
  font-size: 11px;
  padding: 2px 2px 2px 5px !important;
}
</style>
